export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
export const AUTH0_SCOPE = import.meta.env.VITE_AUTH0_SCOPE;
export const AUTH0_CACHE_LOCATION =
  import.meta.env.VITE_AUTH0_CACHE_LOCATION || 'memory';
